export {
  default as SessionProvider,
  Context as SessionContext,
} from "./SessionContext";
export {
  getSession,
  isActiveSession,
  updateSessionActivity,
  clearStorage,
  getRatingScore,
  setRatingScore,
  getPassedOrSkippedFlowComponentsIdFromStorage,
  addPassedOrSkippedFlowComponentIdToStorage,
  type PippaSession,
} from "../helpers/localStorageHelper";
